import { useEffect, useState } from "react";

/**
 * Fetch all prices from server
 * @param {boolean} enabled
 */
export default function useGetPrices(enabled = true) {
  const [prices, setPrice] = useState([]);
  const [workType, setWorkType] = useState([])
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    fetchData();
  }, [enabled]);

  async function fetchData() {
    // Using this dummy data bcos pricing isn't needed anymore, what's needed is just the seniority
    const data = [
      {
        id: 1,
        stack_id: 1,
        seniority: "entry level",
        lower_price: 15,
        higher_price: 25,
        created_at: "2024-11-27 19:04:30",
        updated_at: "2024-11-27 19:04:30",
      },
      {
        id: 2,
        stack_id: 1,
        seniority: "junior",
        lower_price: 15,
        higher_price: 25,
        created_at: "2024-11-27 19:04:30",
        updated_at: "2024-11-27 19:04:30",
      },

      {
        id: 3,
        stack_id: 1,
        seniority: "mid",
        lower_price: 15,
        higher_price: 25,
        created_at: "2024-11-27 19:04:30",
        updated_at: "2024-11-27 19:04:30",
      },
      {
        id: 4,
        stack_id: 1,
        seniority: "senior",
        lower_price: 88,
        higher_price: 113,
        created_at: "2024-11-27 19:04:30",
        updated_at: "2024-11-27 19:04:30",
      },
      {
        id: 5,
        stack_id: 1,
        seniority: "manager",
        lower_price: 150,
        higher_price: 200,
        created_at: "2024-11-27 19:04:30",
        updated_at: "2024-11-27 19:04:30",
      },
      {
        id: 6,
        stack_id: 1,
        seniority: "director",
        lower_price: 250,
        higher_price: 350,
        created_at: "2024-11-27 19:04:30",
        updated_at: "2024-11-27 19:04:30",
      },
      {
        id: 7,
        stack_id: 1,
        seniority: "executive",
        lower_price: 400,
        higher_price: 600,
        created_at: "2024-11-27 19:04:30",
        updated_at: "2024-11-27 19:04:30",
      },
    ];
    setPrice(data);

      const workData = [

       {
        id: 1,
        stack_id: 1,
         title: "contract",
        lower_price: 25,
        higher_price: 50,
        created_at: "2024-11-27 19:04:30",
        updated_at: "2024-11-27 19:04:30",
      },
      {
        id: 2,
        stack_id: 1,
        title: "full-time",
        lower_price: 38,
        higher_price: 75,
        created_at: "2024-11-27 19:04:30",
        updated_at: "2024-11-27 19:04:30",
      },
      // {
      //   id: 3,
      //   stack_id: 1,
      //   title: "part-time",
      //   lower_price: 88,
      //   higher_price: 113,
      //   created_at: "2024-11-27 19:04:30",
      //   updated_at: "2024-11-27 19:04:30",
      // },

    ]
    setWorkType(workData)

    // for (let each of data) {
    //   if (each.seniority === level) {
    //     setIsPriceSelected(true)
    //     setSelectedPrice(
    //       `$${each.lower_price} - $${each.higher_price}`
    //     )
    //     return
    //   }
    // }
    // if (!location || !stackId) return

    // try {
    //   const res = await simpleHttp.get(`/api/v1/all/getPrice/${location}/${stackId}`)
    //   if (res?.status === true) {
    //     // Using this dummy data bcos pricing isn't needed anymore, what's needed is just the seniority
    //     const data = [
    //       {
    //         "id": 1,
    //         "stack_id": 1,
    //         "seniority": "junior",
    //         "lower_price": 25,
    //         "higher_price": 50,
    //         "created_at": "2024-11-27 19:04:30",
    //         "updated_at": "2024-11-27 19:04:30"
    //       },
    //       {
    //         "id": 2,
    //         "stack_id": 1,
    //         "seniority": "mid",
    //         "lower_price": 38,
    //         "higher_price": 75,
    //         "created_at": "2024-11-27 19:04:30",
    //         "updated_at": "2024-11-27 19:04:30"
    //       },
    //       {
    //         "id": 3,
    //         "stack_id": 1,
    //         "seniority": "senior",
    //         "lower_price": 88,
    //         "higher_price": 113,
    //         "created_at": "2024-11-27 19:04:30",
    //         "updated_at": "2024-11-27 19:04:30"
    //       }
    //     ]
    //     setPrice(data)
    //     setShowPrice(true)

    //     for (let each of res?.data) {
    //       if (each.seniority === level) {
    //         setIsPriceSelected(true)
    //         setSelectedPrice(
    //           `$${each.lower_price} - $${each.higher_price}`
    //         )
    //         return
    //       }
    //     }
    //   } else {
    //     // toast.error(res?.error?.message ?? '')
    //   }
    // } catch (error) {
    //   console.log(error)
    // }
  }

  return { loading, prices, workType, error };
}
